export default __webpack_public_path__ + "static/media/x_square.f2a63950.svg";